import { createSelector } from 'reselect';

export const getVehiclesAccesor = state => state.vehicles.vehicles;

export const vehiclesSelector = createSelector(getVehiclesAccesor, state => state);

export const vehicleAuditSelector = createSelector(
    getVehiclesAccesor,
    (vehiclesState) => vehiclesState.audits
);

export const vehicleTicketsSelector = createSelector(
    getVehiclesAccesor,
    (vehiclesState) => vehiclesState.tickets
);

export const vehicleErrorSelector = createSelector(
    getVehiclesAccesor,
    (vehiclesState) => vehiclesState.error
);